// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-dialog {
  margin-top: 10rem;
}

.container {
  max-width: 1040px;
}

.row {
  row-gap: 10px;
}

.event-list-page {
  padding-top: 12px;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-list/event-list.component.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,oCAAA;AAAJ;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,iBAAA;AADF","sourcesContent":[".modal {\n  &.show {\n    display: block;\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n}\n\n.modal-dialog {\n  margin-top: 10rem;\n}\n\n.container {\n  max-width: 1040px;\n}\n\n.row {\n  row-gap: 10px;\n}\n\n.event-list-page {\n  padding-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
